import React from "react";
import Admin from "../components/Admin/Admin";
export default function AdminPage() {
  return <Admin />;
}
